export default __webpack_public_path__ + "static/pc-carousel-01-b9dceff115ee0758c3f5e5ea09c14f6c.jpg";